import { LinkGame } from '@/components/LinkGame';
import { OddsVariant } from '@/config/odds/OddsVariant';
import Logo from './Logo';
import { LogoVariant } from './LogoVariant';

export default function LotteryComparison({
  data,
}: {
  data: [
    { quote: string; game: string; items: [{ title: string; text: string }] },
  ];
}) {
  const VARIANTS = {
    '1': {
      name: OddsVariant.Eurojackpot,
      alt: 'Eurojackpot-Logo',
      logo: LogoVariant.Eurojackpot,
    },
    '2': {
      name: OddsVariant.GluecksSpirale,
      alt: 'GlücksSpirale-Logo',
      logo: LogoVariant.GluecksSpirale,
    },
    '3': {
      name: OddsVariant.Keno,
      alt: 'KENO-Logo',
      logo: LogoVariant.Keno,
    },
    '4': {
      name: OddsVariant.Lotto6aus49,
      alt: 'LOTTO 6aus49-Logo',
      logo: LogoVariant.Lotto6aus49,
    },
  };

  return (
    <div className="LotteryComparison">
      {data.map(({ quote, game, items }) => {
        const gameData = VARIANTS[game];
        const shortname = gameData.name;
        return (
          <div key={game} className="LotteryComparisonItem">
            <div
              className={`LotteryComparisonItem__header LotteryComparisonItem__header--${shortname}`}
            >
              <Logo
                className="Logo"
                variant={gameData.logo}
                title={gameData.alt}
              />
              <span className="LotteryComparisonItem__quote">{quote}</span>
            </div>
            <div className="LotteryComparisonItem__contents">
              {items.map(({ title, text }) => {
                return (
                  <div key={title} className="LotteryComparisonItem__item">
                    <span className="LotteryComparisonItem__title">
                      {title}
                    </span>
                    <div className="LotteryComparisonItem__text">
                      <div className="richtext">
                        <p>{text}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="LotteryComparisonItem__button">
              <div className="LotteryComparisonItem__buttonContainer">
                <LinkGame game={game} small={true} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
